<template>
  <div
    :style=contStyle
    class="bg-white-80 z-20 rounded m-1 transition-all transition-500 overflow-hidden">
    <p class="text-">{{mainTitle}}</p>
    <div :style=divStyle class="mt-2">
      <svg
        :style=svgStyle
        class=''
        id="legendSvg">
      </svg>
      <canvas
        :style=svgStyle
        id="tempLegendCanvas"
        class="hidden">
      </canvas>
    </div>
  </div>
</template>

<script>
import * as d3Legend from 'd3-svg-legend';
import * as d3 from 'd3';

export default {
  props: {
    scale: {
      type: Function,
      default: null,
    },
    variable: {
      type: Object,
      default: {},
    },
    mainTitle: {
      type: String,
      default: 'Addresses'
    }
  },
  data() {
    return {
      legend: null,
      size: {
        width: 0,
        height: 0,
        hPadding: 10,
        vPadding: 10,
      }
    };
  },
  computed: {
    contStyle() {
      const padding = `${this.size.vPadding}px ${this.size.hPadding}px`;
      return {
        padding
      };
    },
    divStyle() {
      const totalHPadding = this.size.hPadding * 2;
      const totalVPadding = this.size.vPadding * 2;
      return {
        width: `${this.size.width + totalHPadding}px`,
        height: `${this.size.height}px`
      };
    },
    svgStyle() {
      return {
        width: `${this.size.width}px`,
        height: `${this.size.height}px`,
        'font-size': '14px',
      };
    }
  },
  methods: {
    initLegend() {
      if (this.scale) {
        this.legend = d3Legend.legendColor()
          .titleWidth(120)
          .labelFormat(this.getFormatter())
          .labels(this.quantileLabel)
          .title(this.title())
          .titleWidth(150)
          .scale(this.scale);
        d3.selectAll('#legendSvg > *').remove();
        const svg = d3.select('#legendSvg');
        const g = svg.append('g')
          .attr('class', 'legendQuant')
          .attr('transform', 'translate(0,16)');
        svg.select('.legendQuant')
          .call(this.legend);
        const bbox = g.node().getBBox();
        this.setSize(bbox.width, bbox.height);
      }
    },
    scientificToDecimal(rawNumber) { // https://gist.github.com/jiggzson/b5f489af9ad931e3d186
      let number = rawNumber.toString()
      let numberHasSign = number.startsWith("-") || number.startsWith("+");
      let sign = numberHasSign ? number[0] : "";
      number = numberHasSign ? number.replace(sign, "") : number;
      //if the number is in scientific notation remove it
      if (/\d+\.?\d*e[\+\-]*\d+/i.test(number)) {
        let zero = '0';
        let parts = String(number).toLowerCase().split('e'); //split into coeff and exponent
        let e = parts.pop();//store the exponential part
        let l = Math.abs(e); //get the number of zeros
        let sign = e / l;
        let coeff_array = parts[0].split('.');
        if (sign === -1) {
          coeff_array[0] = Math.abs(coeff_array[0]);
          number = zero + '.' + new Array(l).join(zero) + coeff_array.join('');
        } else {
          let dec = coeff_array[1];
          if (dec) l = l - dec.length;
          number = coeff_array.join('') + new Array(l + 1).join(zero);
        }
      }
      return `${sign}${number}`;
    },
    getFormatter() {
      function countDecimals(number) {
        if (Math.floor(number.valueOf()) == number.valueOf()) {
          return 0;
        }
        return number.toString().split('.')[1].length;
      }
      const bounds = this.scale.clusters ? this.scale.clusters() : this.scale.quantiles();
      let mostDecimalPlaces = Number.NEGATIVE_INFINITY;
      bounds.forEach((bound) => {
        const roundedBound = Number.parseFloat(bound.toFixed(16));
        const decimalPlaces = countDecimals(this.scientificToDecimal(roundedBound));
        mostDecimalPlaces = Math.max(
          decimalPlaces,
          mostDecimalPlaces
        );
      });
      if (mostDecimalPlaces > 0) {
        return d3.format(',.3g')
        // const formatString = `,.${mostDecimalPlaces}f`;
        // return d3.format(formatString);
      }
      return d3.format(',');
    },
    setSize(width, height) {
      this.size.width = width;
      this.size.height = height;
    },
    quantileLabel({i, genLength, generatedLabels, labelDelimiter}) {
      if (i === 0) {
        const values = generatedLabels[i].split(` ${labelDelimiter} `)
        return `Less than ${values[1]}`
      } else if (i === genLength - 1) {
         const values = generatedLabels[i].split(` ${labelDelimiter} `)
         return `${values[0]} or more`
      }
      return generatedLabels[i]
    },
    title() {
      return this.variable.subtitle;
    }
  },
  mounted() {
    this.initLegend();
  },
  watch: {
    scale() {
      this.initLegend();
    },
  },
};
</script>
